<script>
    import { preventDefault } from "svelte/legacy";

    import { createEventDispatcher } from "svelte";
    import tagService from "../service.js";
    import { flatten422Errors, search } from "../../../services/api.svelte.js";
    import { translateErrorMessages } from "../../../services/api.svelte.js";
    import { format } from "svelte-i18n";

    const dispatch = createEventDispatcher();

    let {
        tag,
        vulnerabilities = [],
        assets = [],
        findingsAssociated = $bindable([]),
        parent = "list",
    } = $props();

    let formData = {};
    let formDataPromise;
    let formIsSubmitted = false;
    // API string errors
    let APIerror = null;
    // API 422 errors
    let formApiErrors = {};
    let findings = [];
    let search_results;
    let showDropdown = false;
    let findingsToRemove = $state([]);
    let is_edit;

    // add form
    if (!tag) {
        formDataPromise = Promise.resolve({});
        is_edit = false;
    }
    // edit form
    else {
        formData = {
            name: tag.name,
        };
        is_edit = true;
        if (findingsAssociated.length <= 0 && tag.finding) {
            findingsAssociated = JSON.parse(tag.finding);
        }
    }

    const hydrateFindings = async (findings) => {
        for (let fnd of findings) {
            let asset = assets.find((asset) => asset.id === fnd.asset_id);
            let vulnerability = vulnerabilities.find(
                (vul) => vul.id === fnd.vulnerability_id,
            );
            fnd.vulnerability = vulnerability
                ? vulnerability.title_es || vulnerability.title
                : "";
            fnd.priority = vulnerability ? vulnerability.priority : "";
            fnd.level = vulnerability ? vulnerability.level : "";
            fnd.asset = asset ? asset : {};
            fnd.name =
                vulnerability && asset
                    ? fnd.vulnerability + " - " + fnd.asset.name
                    : "";
        }
        //return findingsAssociated = findings;
        return findings;
    };

    function handleSubmit() {
        formIsSubmitted = true;
        // reset API errors
        formApiErrors = {};
        let reqData = {};

        if (findingsToRemove.length > 0) {
            for (let finding of findingsToRemove) {
                reqData = {
                    tag_id: tag.id,
                    target_object_type: "Finding",
                    target_object_id: finding.id,
                };
                tagService
                    .deleteAssociation(reqData, [], {})
                    .then((response) => {
                        dispatch("save", { tag });
                        //clear formData and form status and errors
                        // when modal is closed after sending add request
                        formData = {};
                        formIsSubmitted = false;
                        formApiErrors = {};
                        return true;
                    })
                    .catch((errors) => {
                        if (typeof errors.detail == "string") {
                            APIerror = translateErrorMessages(
                                errors.detail,
                                "Etiquetas",
                            );
                        } else {
                            // parse API errors
                            formApiErrors = flatten422Errors(errors);
                        }

                        return false;
                    });
            }
        }
    }
    const removeAssociatedFinding = (i) => {
        findingsToRemove.push(findingsAssociated[i]);
        findingsAssociated.splice(i, 1);
        findingsAssociated = findingsAssociated;
    };

    function handleCloseModal() {
        formData = {};
        formApiErrors = {};
        formIsSubmitted = false;
        formIsSubmitted = false;
        showDropdown = true;
        APIerror = null;
        findings = [];
        search_results = [];
        dispatch("closeModal");
    }

    const handleKeydown = (event) => {
        if (event.key == "Escape") {
            handleCloseModal();
        } else {
            return;
        }
    };
</script>

<svelte:window onkeydown={handleKeydown} />

<form role="form" novalidate onsubmit={preventDefault(handleSubmit)}>
    <div class="card">
        <div class="card-body">
            {#if tag}
                <div class="mb-3">
                    <label for="name"
                        >{$format("form.fields.name")}<span class="text-danger"
                            >*</span
                        ></label
                    >
                    <span class="d-block">{tag.name}</span>
                </div>
                {#if parent == "list"}
                    {#await hydrateFindings(JSON.parse(tag.finding)) then success}
                        <label for="associatedFindings"
                            >{$format("page.tag.associated_findings")}:</label
                        >
                        {#if findingsAssociated.length > 0}
                            {#each findingsAssociated as finding, i}
                                <div>
                                    {finding.vulnerability}<i
                                        class="fas fa-times btnDeleteFinding float-end"
                                        onclick={() =>
                                            removeAssociatedFinding(
                                                i,
                                                findingsAssociated,
                                            )}
                                    ></i>
                                </div>
                            {/each}
                        {/if}
                    {/await}
                {:else}
                    <label for="associatedFindings"
                        >{$format("page.tag.associated_findings")}:</label
                    >
                    {#each findingsAssociated as finding, i}
                        <div>
                            {finding.name}<i
                                class="fas fa-times btnDeleteFinding float-end"
                                onclick={() =>
                                    removeAssociatedFinding(
                                        i,
                                        findingsAssociated,
                                    )}
                            ></i>
                        </div>
                    {/each}
                {/if}
            {/if}
        </div>
        <div class="card-footer">
            <button type="submit" class="btn btn-primary t-submit-tag-btn"
                >{$format("buttons.save")}</button
            >
            <button
                type="button"
                class="btn btn-default"
                data-bs-dismiss="modal"
            >
                {$format("buttons.cancel")}
            </button>
        </div>
    </div>
</form>

<style>
    .btnDeleteFinding {
        cursor: pointer;
    }
</style>
